<div class="formulabar-component">
  <span class="fx" *ngIf="showFx">fx</span>
  <div id="formulabar">
    <div
      class="fbar-container"
      [ngClass]="
        loadTree && fbarExpanded
          ? 'expanded-fbar-container'
          : 'collapsed-fbar-container'
      "
    >
      <div
        class="tree-poc"
        *ngIf="!isLoading"
        [ngClass]="loadTree && fbarExpanded ? 'expanded-fbar' : ''"
      >
        <nz-spin *ngIf="isLoading" nzSimple [nzSize]="'small'"></nz-spin>
        <nz-tree
          #nzTreeComponent
          [nzData]="treeData"
          [nzTreeTemplate]="formulaTreeTemplate"
          (nzClick)="onFbarClick($event.node)"
          [nzExpandedKeys]="defaultExpandedKeys"
          (nzExpandChange)="onExpandRootNode($event.node)"
          [nzExpandedIcon]="doubleArrowExpandIcon"
          *ngIf="!isLoading && loadTree"
          nzExpandAll="true"
        >
        </nz-tree>
      </div>

      <!-- If no expression_error flag-->
      <div *ngIf="statusError">
        <span class="zero"
          ><b>{{ errorMessage }}</b></span
        >
      </div>
      <nz-spin *ngIf="isLoading" nzSimple [nzSize]="'small'"></nz-spin>
    </div>
  </div>

  <ng-template #formulaTreeTemplate let-node let-origin="origin">
    <div *ngIf="isRootNode(node)" title="">
      <span
        nz-tooltip
        nzTooltipPlacement="right"
        nzTooltipTitle="{{ origin.ColumnName }} = {{ origin.summary }}"
      >
        <b>
          {{ origin.ColumnName }}
        </b>
        = {{ origin.summary }}
      </span>
    </div>
    <div *ngIf="!isRootNode(node)" class="child-node">
      <span
        class="indications-phase"
        *ngIf="colName === 'indications'"
        nz-tooltip
        nzTooltipPlacement="right"
        nzTooltipTitle="{{ node.origin.phase }}"
      >
        {{ phaseAbbr[node.origin.phase] }}
      </span>
      <span class="formulaBar-name formulabar-name-truncate">
        <span
          nz-tooltip
          nzTooltipPlacement="right"
          nzTooltipTitle="{{ node.origin.name }}"
        >
          {{ node.origin.name }}
        </span>
      </span>
      <span class="formulaBar-link">
        <span
          *ngIf="node.origin.shortname !== null || node.origin.shortname !== ''"
          (click)="redirectToCompanyPage(node.origin.link)"
        >
          <a
            nz-tooltip
            nzTooltipPlacement="right"
            nzTooltipTitle="{{ node.origin.link }}"
          >
            {{ node.origin.shortname }}</a
          >
        </span>
        <span
          *ngIf="node.origin.shortname === null || node.origin.shortname === ''"
        >
          <p>Source Not Available</p>
        </span>
      </span>
      <span class="formulaBar-date">
        <span
          nz-tooltip
          nzTooltipPlacement="right"
          nzTooltipTitle="{{ node.origin.date }}"
        >
          {{ node.origin.date }}
        </span>
      </span>
    </div>
  </ng-template>

  <!-- custom icon template -->
  <ng-template #doubleArrowExpandIcon let-node>
    <i *ngIf="isRootNode(node) && !node.isDisabled">
      <va-icon
        size="large"
        class="ant-tree-switcher-icon"
        [ngClass]="{ 'dbl-arrow': true, 'dbl-arrow-expanded': node.expanded }"
        name="caret-right"
      ></va-icon>
    </i>
  </ng-template>
</div>
